import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=4b2ff770&scoped=true&"
import script from "./Ad.vue?vue&type=script&lang=ts&"
export * from "./Ad.vue?vue&type=script&lang=ts&"
import style0 from "./Ad.vue?vue&type=style&index=0&id=4b2ff770&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ff770",
  null
  
)

export default component.exports